import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import api from '../../services/api';
import { useFilters } from '../../hooks/projectFilters';
import HowWorksSection from '../../components/HowWorksSection';
import BecomeDesignerSection from '../../components/BecomeDesignerSection';
import ProjectCard from '../../components/ProjectCard';
import ProjectsExplorer from '../../components/ProjectsExplorer';
import RankCard from '../../components/RankCard';
import SearchBox from '../../components/SearchBox';
import SectionHead from '../../components/SectionHead';

import {
  Eyebrow,
  Hero,
  HeroLead,
  HeroTitle,
  ProjectsGrid,
  RankRail,
  Section,
} from './styles';

const RECENT_LIMIT = 8;
const MOST_DOWNLOADED_LIMIT = 6;

const Home = () => {
  const history = useHistory();
  const { resetFilters } = useFilters();

  const [recentProjects, setRecentProjects] = useState([]);
  const [mostDownloaded, setMostDownloaded] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        // As duas vitrines saem da mesma listagem de projetos aprovados,
        // mudando só a ordenação — sem endpoint dedicado.
        const [recent, downloaded] = await Promise.all([
          api.get('/projects', {
            params: { sort: 'recent', limit: RECENT_LIMIT, page: 1 },
          }),
          api.get('/projects', {
            params: {
              sort: 'downloads',
              limit: MOST_DOWNLOADED_LIMIT,
              page: 1,
            },
          }),
        ]);

        setRecentProjects(recent.data.projects);
        setMostDownloaded(
          downloaded.data.projects.filter(p => p.downloadsCount > 0)
        );
      } catch {
        // As vitrines simplesmente não aparecem; o restante da home continua.
      }
    })();
  }, []);

  function goToProjects() {
    resetFilters();
    history.push('/projects');
  }

  return (
    <>
      <Hero>
        <Eyebrow>Portal Due It</Eyebrow>
        <HeroTitle>O que você vai criar hoje?</HeroTitle>
        <HeroLead>
          Explore projetos, descubra novas ideias e veja o que a comunidade Due
          está criando.
        </HeroLead>
        <SearchBox />
      </Hero>

      <HowWorksSection />

      {recentProjects.length > 0 && (
        <Section>
          <SectionHead
            title="Acabaram de chegar"
            description="Os projetos mais recentes publicados pela comunidade."
            actionLabel="Ver todos"
            onActionClick={goToProjects}
          />
          <ProjectsGrid>
            {recentProjects.map(project => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </ProjectsGrid>
        </Section>
      )}

      {mostDownloaded.length > 0 && (
        <Section>
          <SectionHead
            title="Mais baixados"
            description="O que a comunidade está criando mais."
          />
          <RankRail>
            {mostDownloaded.map((project, index) => (
              <RankCard key={project.id} project={project} rank={index + 1} />
            ))}
          </RankRail>
        </Section>
      )}

      <Section>
        <SectionHead
          title="Explorar"
          description="Encontre o projeto certo para o que você quer criar — filtre por categoria, material ou preço."
        />
        <ProjectsExplorer />
      </Section>

      <BecomeDesignerSection />
    </>
  );
};

export default Home;
